import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import LoadingState from "./state";
import LoadingPayload from './payload';

export default createSlice({
  name: "loading",
  initialState: {
    isOpen: true,
    message: ''
  } as LoadingState,
  reducers: {
    updateLoading: (state, action: PayloadAction<LoadingPayload>) => {
      return {
        ...state,
        isOpen: action.payload.isOpen,
        message: action.payload.message
      }
    },
  },
});